import axios from "axios";
import {getToken} from "./auth.service";

export const APIChatEnpoint = {
    finfmessageslink: "/api/find/messageslink",
  };

const generateMyGroupEndpoint = (search:String, limit:any, offset:any) => {
    return `api/v2/groups/?search=${search}&limit=${limit}&offset=${offset}`;
};

const generateFindAllEndpoint = (search:String, limit:any, offset:any) => {
    return `api/v2/groups/?search=${search}&limit=${limit}&offset=${offset}&isMyGroup=false`;
  };

export const APIEndpoint = {
    myGroup: generateMyGroupEndpoint,
    findAll: generateFindAllEndpoint,
    groups: 'api/v2/groups/',
};

export const findMyGroup = async (search:String, limit:any, offset:any) => {
    return await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.myGroup(search, limit, offset),
        {
            headers: { Authorization: `Bearer ${getToken()}` },
        }
    );
};

export const findAll = async (search:String, limit:any, offset:any) => {
    return await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.findAll(search, limit, offset),
        {
            headers: { Authorization: `Bearer ${getToken()}` },
        }
    );
};

export const groups = async () => {
    return await axios.get(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + APIEndpoint.groups,
        {
            headers: { Authorization: `Bearer ${getToken()}` },
        }
    );
};